export default "__VITE_ASSET__DycBqEWe__"